import qs from "qs";
import { BooksActionItems } from "types/Models/books";
import { emptyApi } from "./emptyApi";
import { TransactionQuery } from "./transactions";
import { FileUrl } from "types/Models/fileObject";
import { TxnGroupBy } from "constants/bookkeeping";

export type RecentFinancialDocument = {
  uuid: string;
  name: string;
  group_id: string;
  parent_uuid: string;
  parent_name: string;
  document_path: string;
  is_previewable: boolean;
  is_locked: boolean;
  is_private: boolean;
  file_type: string;
  type: string;
  file_size: number;
  owner: null;
  created_at: string;
  thumbnail_file_id: string;
};

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    exportTxn: build.query<
      FileUrl,
      TransactionQuery & { groupBy?: TxnGroupBy | null }
    >({
      query: ({
        groupId,
        entityId,
        page_num,
        searchTerm,
        transactionIds,
        startDate,
        endDate,
        fromIds,
        manualEntry,
        bankStatement,
        vendors,
        categoryIds,
        uncategorized,
        cashFlow,
        minAmount,
        maxAmount,
        hasMemo,
        hasComments,
        hasInvoices,
        sortCol,
        sortOrder,
        hasNoVendors,
        splitTransactions,
        fetch_page_num,
        jump_txn_id,
        reviewed,
        notReviewed,
        txnAccountType,
        pageSize,
        groupBy,
      }) => {
        let queryUrl = qs.stringify(
          {
            search_term: searchTerm,
            transaction_ids: transactionIds,
            start_date: startDate?.value,
            end_date: endDate?.value,
            journal_entry: manualEntry?.value,
            bank_statement: bankStatement?.value,
            //@ts-ignore
            from_ids: fromIds?.value?.join(","),
            //@ts-ignore
            merchants: vendors?.value?.join(","),
            //@ts-ignore
            category_ids: categoryIds?.value?.join(","),
            uncategorized: uncategorized?.value,
            cash_flow: cashFlow?.value,
            min_amount: minAmount,
            max_amount: maxAmount,
            has_memo: hasMemo?.value,
            has_comments: hasComments?.value,
            has_invoices: hasInvoices?.value,
            has_no_merchants: hasNoVendors?.value,
            has_split_transactions: splitTransactions?.value,
            sort_col: sortCol,
            sort_order: sortOrder,
            reviewed: reviewed?.value,
            not_reviewed: notReviewed?.value,
            fetch_page_num,
            jump_txn_id,
            txn_account_type: txnAccountType || null,
            page_size: pageSize,
            group_by: groupBy,
          },
          {
            filter: (prefix, value) =>
              value === false || value === "" ? undefined : value,
            skipNulls: true,
          }
        );
        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/entity_transactions/txn_export/`,
          params: {
            ...qs.parse(queryUrl),
          },
        };
      },
    }),
    booksActionItems: build.query<
      BooksActionItems,
      { groupId: string; entityId: string }
    >({
      query: ({ groupId, entityId }) => {
        return {
          url: `/api/inkle/bookkeeping/group/${groupId}/entity/${entityId}/action_items/`,
        };
      },
      providesTags: ["REPORTS"],
    }),
    getRecentFinancials: build.query<
      RecentFinancialDocument[],
      { entityId: string }
    >({
      query: ({ entityId }) =>
        `/api/inkle/bookkeeping/entity/${entityId}/recent-financials/`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyExportTxnQuery,
  useBooksActionItemsQuery,
  useGetRecentFinancialsQuery,
} = extendedApi;
